export async function getIsAbleToPurchaseOnStorefront() {
    return true;
}
//# sourceMappingURL=getIsAbleToPurchaseOnStorefront.js.map